import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/hooks";
import { useEffect, useState } from "react";
import { getCardData, getFunctionCardData } from "../../common/services/website-card.service";
import { useNavigate } from "react-router-dom";
import { selectCurrent } from "../../redux/settings/selectors";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import { selectOrganizationUnitsListItems } from "../../redux/organizationUnits/selector";
import { toast } from "react-toastify";
import { newsletterSubscriptions } from "../../redux/news-letter-subscription/action";
import { selectCmsSettingsListItems } from "../../redux/cmsSettings/selector";
import { selectWebsiteCardsListItems } from "../../redux/websiteCards/selector";
import { selectTermsLibrariesListItems } from "../../redux/terms-libraries/selector";
import { termsLibraries } from "../../redux/terms-libraries/action";
import _ from "lodash";
import { HTMLContent } from "../../common/components/html-content";
import storePersist from "../../redux/storePersist";

const Footer = () => {
	const dispatch = useAppDispatch()
	const { height, width } = useWindowDimensions();
	const result = useSelector(selectCurrent)
	const { header, footer, visible, sidebar, theme, lightLogo, darkLogo, primary, secondary } = result
	const [subscriptionData, getsubscriptionData] = useState<any>();
	const [ouDetails, setOUDetails] = useState<any>();
	const [socialIconData, setSocialIconData] = useState<any>();
	const [copyRightsContent, setCopyRightsContent] = useState<any>();
	const guestTokenmetaData = storePersist.get("guestTokenMetadata").current?.result?.TokenMetadata?.CompanyName;
	const navigate = useNavigate()
	const [logo, setLogo] = useState<any>()
	const websiteCardsList = useSelector(selectWebsiteCardsListItems);
	const address = `${ouDetails?.PrimaryAddress?.Address1} , ${ouDetails?.PrimaryAddress?.Address2} , ${ouDetails?.PrimaryAddress?.City} - ${ouDetails?.PrimaryAddress?.ZipPostalCode},${ouDetails?.PrimaryAddress?.StateProvince?.Name},${ouDetails?.PrimaryAddress?.Country?.Name}.`;
	const phoneNumber = ouDetails?.OrganizationUnitInfo?.PhoneNumber
	const email = ouDetails?.OrganizationUnitInfo?.Email
	const cmsSettings = useSelector(selectCmsSettingsListItems)
	const handleNavigate = (path: any) => {
		navigate(`${path}`)
	}
	const termsLibraryListItems = useSelector(selectTermsLibrariesListItems)
	let privacyPolicy = _.find(termsLibraryListItems.result.items, ['TermsNameLibraryId', 50]);
	let termsOfUse = _.find(termsLibraryListItems.result.items, ['TermsNameLibraryId', 40]);


	useEffect(() => {
		setLogo(darkLogo || lightLogo)
	}, [result]);

	const handleChange: any = (event: any, field: string) => {
		getsubscriptionData({ ...subscriptionData, [field]: event })
	}
	const handleSubmit = async (event: any) => {
		event.preventDefault();
		dispatch(newsletterSubscriptions.create({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/news-letter-subscriptions`, entity: 'newsletterSubscriptions', jsonData:
			{
				"Records": [
					{
						"Email": subscriptionData?.Email,
						"Active": true
					}
				]
			}
		})).then(() => {
			getsubscriptionData('')
			toast.success('Thanks for you interest. We will email you the coupon...')
		})
	}

	const handleTrackClick = () => {
		navigate('/customer/order/track')
	}
	const handleMobilePrograms = () => {
		navigate('/program')
	}
	const handleMobileEvents = () => {
		navigate('/event')
	}
	const handleMobileCommunities = () => {
		navigate('/community')
	}
	const handleSupport = async () => {
		navigate('customer/support')
	}

	const getCardDetails = async () => {

		const ouDetails: any = getFunctionCardData(websiteCardsList?.result?.items, 'OU_DETAILS');
		setOUDetails(ouDetails)
		const footerSocialIconData: any = getCardData(websiteCardsList?.result?.items, 'LOGISTICS_QDP_FOOTER_SOCIALICON');
		setSocialIconData(footerSocialIconData)
		const copyRightsContent: any = getCardData(websiteCardsList?.result?.items, 'LOGISTICS_QDP_COPYRIGHTS');
		setCopyRightsContent(copyRightsContent)
	}

	useEffect(() => {
		getCardDetails();
		dispatch(termsLibraries.list({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/terms-libraries/list`, entity: 'termsLibraries', jsonData: {}
		}))
	}, []);

	return (
		<>
			{width && width < 720 ?
				// start mobile view
				<footer className={`max-h-screen fixed -bottom-1 z-[200] w-screen bg-primary text-white h-20`}>
					<ul className="flex flex-row justify-around items-center w-full p-3">
						<li onClick={() => navigate('/')} className=" flex flex-col items-center justify-center space-y-2">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
								<path d="M12 17H12.009" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M20 8.5V13.5C20 17.2712 20 19.1569 18.8284 20.3284C17.6569 21.5 15.7712 21.5 12 21.5C8.22876 21.5 6.34315 21.5 5.17157 20.3284C4 19.1569 4 17.2712 4 13.5V8.5" stroke="currentColor" stroke-width="1.5" />
								<path d="M22 10.5L17.6569 6.33548C14.9902 3.77849 13.6569 2.5 12 2.5C10.3431 2.5 9.00981 3.77849 6.34315 6.33548L2 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
							</svg>
							<span className="text-light hover:text-[#FFB934] text-xs">Home</span>
						</li>
						<li
							onClick={handleMobilePrograms}
							className=" flex flex-col items-center justify-center space-y-2">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
								<path d="M2 13.4286V8H22V13.4286C22 17.4692 22 19.4895 20.6983 20.7447C19.3965 22 17.3014 22 13.1111 22H10.8889C6.69863 22 4.6035 22 3.30175 20.7447C2 19.4895 2 17.4692 2 13.4286Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M2 8L2.96154 5.69231C3.70726 3.90257 4.08013 3.0077 4.8359 2.50385C5.59167 2 6.56112 2 8.5 2H15.5C17.4389 2 18.4083 2 19.1641 2.50385C19.9199 3.0077 20.2927 3.90257 21.0385 5.69231L22 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
								<path d="M12 8V2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
								<path d="M10 12H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
							</svg>
							<span className="text-light hover:text-[#FFB934] text-xs">Programs</span>
						</li>
						{cmsSettings?.result?.items?.LogisticsSettings?.Cargo &&
							<li onClick={() => navigate('/cargo')}
								className="flex flex-col items-center justify-center space-y-2" >
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
									<path d="M19.5 17.5C19.5 18.8807 18.3807 20 17 20C15.6193 20 14.5 18.8807 14.5 17.5C14.5 16.1193 15.6193 15 17 15C18.3807 15 19.5 16.1193 19.5 17.5Z" stroke="currentColor" stroke-width="1.5" />
									<path d="M9.5 17.5C9.5 18.8807 8.38071 20 7 20C5.61929 20 4.5 18.8807 4.5 17.5C4.5 16.1193 5.61929 15 7 15C8.38071 15 9.5 16.1193 9.5 17.5Z" stroke="currentColor" stroke-width="1.5" />
									<path d="M14.5 17.5H9.5M15 15.5V7C15 5.58579 15 4.87868 14.5607 4.43934C14.1213 4 13.4142 4 12 4H5C3.58579 4 2.87868 4 2.43934 4.43934C2 4.87868 2 5.58579 2 7V15C2 15.9346 2 16.4019 2.20096 16.75C2.33261 16.978 2.52197 17.1674 2.75 17.299C3.09808 17.5 3.56538 17.5 4.5 17.5M15.5 6.5H17.3014C18.1311 6.5 18.5459 6.5 18.8898 6.6947C19.2336 6.8894 19.4471 7.2451 19.8739 7.95651L21.5725 10.7875C21.7849 11.1415 21.8911 11.3186 21.9456 11.5151C22 11.7116 22 11.918 22 12.331V15C22 15.9346 22 16.4019 21.799 16.75C21.6674 16.978 21.478 17.1674 21.25 17.299C20.9019 17.5 20.4346 17.5 19.5 17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<span className="text-light hover:text-[#FFB934] text-xs">Cargo Order</span>
							</li>}
						<li onClick={handleMobileEvents} className=" flex flex-col items-center justify-center space-y-2">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
								<path d="M2 13.4286V8H22V13.4286C22 17.4692 22 19.4895 20.6983 20.7447C19.3965 22 17.3014 22 13.1111 22H10.8889C6.69863 22 4.6035 22 3.30175 20.7447C2 19.4895 2 17.4692 2 13.4286Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M2 8L2.96154 5.69231C3.70726 3.90257 4.08013 3.0077 4.8359 2.50385C5.59167 2 6.56112 2 8.5 2H15.5C17.4389 2 18.4083 2 19.1641 2.50385C19.9199 3.0077 20.2927 3.90257 21.0385 5.69231L22 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
								<path d="M12 8V2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
								<path d="M10 12H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
							</svg>
							<span className="text-light hover:text-[#FFB934] text-xs">Events</span>
						</li>


						<li onClick={handleMobileCommunities} className=" flex flex-col items-center justify-center space-y-2">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
								<path d="M2 13.4286V8H22V13.4286C22 17.4692 22 19.4895 20.6983 20.7447C19.3965 22 17.3014 22 13.1111 22H10.8889C6.69863 22 4.6035 22 3.30175 20.7447C2 19.4895 2 17.4692 2 13.4286Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M2 8L2.96154 5.69231C3.70726 3.90257 4.08013 3.0077 4.8359 2.50385C5.59167 2 6.56112 2 8.5 2H15.5C17.4389 2 18.4083 2 19.1641 2.50385C19.9199 3.0077 20.2927 3.90257 21.0385 5.69231L22 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
								<path d="M12 8V2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
								<path d="M10 12H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
							</svg>
							<span className="text-light hover:text-[#FFB934] text-xs">Communities</span>
						</li>

						<li onClick={handleSupport} className=" flex flex-col items-center justify-center space-y-2">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
								<path d="M2 13.4286V8H22V13.4286C22 17.4692 22 19.4895 20.6983 20.7447C19.3965 22 17.3014 22 13.1111 22H10.8889C6.69863 22 4.6035 22 3.30175 20.7447C2 19.4895 2 17.4692 2 13.4286Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M2 8L2.96154 5.69231C3.70726 3.90257 4.08013 3.0077 4.8359 2.50385C5.59167 2 6.56112 2 8.5 2H15.5C17.4389 2 18.4083 2 19.1641 2.50385C19.9199 3.0077 20.2927 3.90257 21.0385 5.69231L22 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
								<path d="M12 8V2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
								<path d="M10 12H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
							</svg>
							<span className="text-light hover:text-[#FFB934] text-xs">Support</span>
						</li>
					</ul>

				</footer >
				// End mobile view				
				:

				<div className={`flex flex-col w-full h-100 bg-primary`}>
					<div className={`w-full flex flex-row items-center h-40 px-10 bg-secondary text-light`}>
						<div className="flex flex-col w-1/2 text-md m-4 pl-10 pr-28">
							<div className="text-xl py-4 text-justify ">Sign up for our newsletter today to stay up-to-date with exclusive discounts, early access to new products, offers</div>

						</div>
						<div className="flex w-1/2">

							<div className=" w-full">

								<div className="border-0 flex flex-row items-center justify-center text-base border-b-2 border-white">

									<input

										type="text" name="serch" placeholder="Enter your Mail Id" className="bg-secondary w-full px-2  text-sm focus:outline-none placeholder-light"
										onChange={(event) => {
											handleChange(
												event.target.value,
												'Email'
											);
										}}
										value={subscriptionData && subscriptionData?.Email} />
									<button onClick={handleSubmit} type="submit" className="relative right-8 top-0 mr-4 flex items-center">
										<span className="text-xl p-4">Subscribe</span> <svg height="64px" width="64px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 227.096 227.096" fill="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <polygon points="152.835,39.285 146.933,45.183 211.113,109.373 0,109.373 0,117.723 211.124,117.723 146.933,181.902 152.835,187.811 227.096,113.55 "></polygon> </g> </g> </g></svg>
									</button>

								</div>
							</div>
						</div>
					</div>
					<div className="w-full flex  py-14 px-20 justify-between items-start border-b-2">

						<div className="w-4/5 h-44 text-2xl" >
							{/* <div className="w-40 h-16 p-2">
								{logo && <img src={logo} className="w-full h-full" />}
							</div> */}
							<div className="flex flex-row ">
								<div className="py-1 ">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
										<path d="M7 18C5.17107 18.4117 4 19.0443 4 19.7537C4 20.9943 7.58172 22 12 22C16.4183 22 20 20.9943 20 19.7537C20 19.0443 18.8289 18.4117 17 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
										<path d="M14.5 9C14.5 10.3807 13.3807 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9Z" stroke="currentColor" stroke-width="1.5" />
										<path d="M13.2574 17.4936C12.9201 17.8184 12.4693 18 12.0002 18C11.531 18 11.0802 17.8184 10.7429 17.4936C7.6543 14.5008 3.51519 11.1575 5.53371 6.30373C6.6251 3.67932 9.24494 2 12.0002 2C14.7554 2 17.3752 3.67933 18.4666 6.30373C20.4826 11.1514 16.3536 14.5111 13.2574 17.4936Z" stroke="currentColor" stroke-width="1.5" />
									</svg>
								</div>
								<span className="text-sm px-2 py-1 w-80 text-light ">
									{address ? address : null}
								</span>
							</div>
							<div className="flex flex-row">
								<div className="p-1">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
										<path d="M4.74038 14.3685L6.69351 12.9816C7.24445 12.5904 7.80305 12.3282 8.44034 12.1585C9.17201 11.9636 9.5 11.5644 9.5 10.711C9.5 8.54628 14.5 8.31594 14.5 10.711C14.5 11.5644 14.828 11.9636 15.5597 12.1585C16.202 12.3295 16.7599 12.5934 17.3065 12.9816L19.2596 14.3685C20.1434 14.9961 20.5547 15.2995 20.7842 15.7819C21 16.2358 21 16.768 21 17.8324C21 19.7461 21 20.703 20.4642 21.3164C19.8152 22.0593 18.128 21.9955 17.0917 21.9955H6.90833C5.87197 21.9955 4.21909 22.0986 3.5358 21.3164C3 20.703 3 19.7461 3 17.8324C3 16.768 3 16.2358 3.21584 15.7819C3.44526 15.2995 3.85662 14.9961 4.74038 14.3685Z" stroke="currentColor" stroke-width="1.5" />
										<path d="M14 17C14 18.1046 13.1046 19 12 19C10.8954 19 10 18.1046 10 17C10 15.8954 10.8954 15 12 15C13.1046 15 14 15.8954 14 17Z" stroke="currentColor" stroke-width="1.5" />
										<path d="M6.96014 3.69772C5.6417 4.07415 4.69384 4.54112 3.82645 5.10455C2.45318 5.9966 1.86443 7.60404 2.02607 9.15513C2.09439 9.81068 2.62064 10.1241 3.23089 9.95455C3.69451 9.82571 4.15888 9.7003 4.61961 9.56364C5.96706 9.16397 6.28399 8.67812 6.47124 7.29885L6.96014 3.69772ZM6.96014 3.69772C10.2186 2.76743 13.7814 2.76743 17.0399 3.69772M17.0399 3.69772C18.3583 4.07415 19.3062 4.54112 20.1735 5.10455C21.5468 5.9966 22.1356 7.60404 21.9739 9.15513C21.9056 9.81068 21.3794 10.1241 20.7691 9.95455C20.3055 9.82571 19.8411 9.7003 19.3804 9.56364C18.0329 9.16397 17.716 8.67812 17.5288 7.29885L17.0399 3.69772Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
									</svg>
								</div>
								<span className="text-sm px-2 py-1 text-light">{phoneNumber ? phoneNumber : null}</span>
							</div>
							<div className="flex flex-row">
								<div className="p-1">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
										<path d="M2 6L8.91302 9.91697C11.4616 11.361 12.5384 11.361 15.087 9.91697L22 6" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
									</svg>
								</div>
								<span className="text-sm px-2 py-1 text-light">{email ? email : null}</span>
							</div>
						</div>
						<div className={`w-2/5 h-full text-light flex flex-col justify-start item-center text-sm`}>
							<div className="text-xl ">Platforms</div>
							<div className="text-[14px]  space-y-2 py-5 cursor-pointer">
								{/* <div className="hover:opacity-75" onClick={() => handleNavigate('/auth/login/management')}> Management</div> */}
								<div className="hover:opacity-75" onClick={() => handleNavigate('/venture/login')}> Ventures</div>
								{/* <div className="hover:opacity-75" onClick={() => handleNavigate('/agencies/login')}> Agencies</div> */}
								{/* <div className="hover:opacity-75" onClick={() => handleNavigate('/mentor/login')}> Mentor</div>
								<div className="hover:opacity-75" onClick={() => handleNavigate('/trainer/login')}> Trainer</div> */}
								<div className="hover:opacity-75" onClick={() => handleNavigate('/candidate/login')}> Candidates</div>
								{/* <div className="hover:opacity-75" onClick={() => handleNavigate('/partner/login')}> Partner</div>  */}

								<div
									className="hover:opacity-75"
									onClick={() => window.open(`https://${guestTokenmetaData}.xe.digiit.${process.env.REACT_APP_API_URL}`, '_blank')}
								>
									iXE
								</div>

							</div>
						</div>
						<div className={`w-2/5 h-full text-light flex flex-col justify-start item-center text-sm`}>
							<div className="text-xl">Helpful Links</div>
							<div className="text-[14px] space-y-2 py-5 cursor-pointer">
								<div className="hover:opacity-75" onClick={() => handleNavigate('/about-us')}> About Us</div>
								<div className="hover:opacity-75" onClick={() => handleNavigate('/customer/contact')}> Contact</div>
								<div className="hover:opacity-75" onClick={() => handleNavigate('/customer/support')}> Support</div>
								{/* <div className="hover:opacity-75" onClick={() => handleNavigate('/customer/order/track')}> Track Order</div> */}
							</div>
						</div>
						<div className={`w-2/5 h-full text-light flex flex-col justify-start item-center text-sm`}>
							<div className="text-xl">Legal</div>
							<div className="text-[14px] space-y-2 py-5 cursor-pointer">
								{termsLibraryListItems?.result?.items?.map((item: any, index: any) => (
									<div key={index} className="hover:opacity-75" onClick={() => handleNavigate(`/terms/${item?.Id}`)}>{item.Name}</div>

								))}
							</div>
						</div>

						<div className={`w-2/5 h-full  flex flex-col justify-start item-center text-sm`}>
							<div className="text-xl text-light">Follow Us</div>
							<div className="text-[14px] space-y-2 py-5 cursor-pointer">
								<div className="flex flex-row mr-0 space-x-5">
									{/* Social Icon */}
									{socialIconData?.map((item: any, index: any) => (
										<a key={index} target="blank" title={item?.title} href={item?.url ? item?.url : '/'}>
											<HTMLContent htmlContent={item?.svg} />
										</a>))}
								</div>
							</div>
						</div>

					</div>
					<div className={`w-full flex py-6 px-16 h-full justify-between items-end bottom-0 text-light `}>
						{copyRightsContent && copyRightsContent.length > 0 && <p className="text-xs">{copyRightsContent ? copyRightsContent[0].title : null}</p>}
						<div className="flex">
							<div onClick={() => handleNavigate(`/terms/${termsOfUse?.Id}`)} className="mr-3  text-xs cursor-pointer">{termsOfUse?.Name} &nbsp;&nbsp; |</div>
							<div onClick={() => handleNavigate(`/terms/${privacyPolicy?.Id}`)} className="mr-3  text-xs cursor-pointer">{privacyPolicy?.Name} &nbsp;&nbsp; |</div>
							<div onClick={() => handleNavigate(`/about-us`)} className=" text-xs cursor-pointer">About Us</div>
						</div>
					</div>
				</div>

			}
		</>

	)
}


export default Footer;